import { useCallback, useEffect, useState } from "react";
import ErrorsString from "../ErrorsString";
import Spinner from "./Spinner";
import Alert from "@mui/material/Alert";
import { ChannelsGridResponse } from "../models/ResponseModels/ChannelsGridResponse";
import { GetChannelsGridModel } from "../models/GetChannelsGridModel";
import config from "../config";
import { useNavigate } from "react-router-dom";

interface Props {
  idPage: string;
}

export default function ChannelsGrid(props: Props) {
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  let [channelsGrid, setChannelsGrid] = useState<ChannelsGridResponse | null>(
    null,
  );
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);
  const navigate = useNavigate();

  const getChannelsGrid = useCallback(() => {
    window.scrollTo(0, 0);
    setSpinnerVisibility(true);

    console.log("Starting API call GetChannelsGridModel...");
    (async () => {
      let response = null;
      response = await GetChannelsGridModel(props.idPage);
      //console.log("GetChannelsGridModel response: " + JSON.stringify(response));

      const responseData = response?.data;
      const statusCode = response?.status;

      if (responseData === undefined) {
        setShowAlert(true);
        setAlertMessage(ErrorsString.errorMessageGeneric);
        setSpinnerVisibility(false);
        return;
      }

      if (statusCode !== 200) {
        setShowAlert(true);
        setAlertMessage(ErrorsString.errorMessageGeneric);
        setSpinnerVisibility(false);
        return;
      }

      if (responseData.code !== "0") {
        setShowAlert(true);
        setAlertMessage(responseData.message);
        setSpinnerVisibility(false);
        return;
      }

      if (responseData.channelGridList) {
        setChannelsGrid(responseData.channelGridList);
        setShowAlert(false);
        setAlertMessage("");
        setSpinnerVisibility(false);
      } else {
        setShowAlert(true);
        setAlertMessage("No channels found");
        setSpinnerVisibility(false);
      }
    })();
  }, [props.idPage]);

  useEffect(() => {
    getChannelsGrid();
  }, [getChannelsGrid]);

  function loadSearchPage(channelIds) {
    const parameters = {
      channelIds: channelIds,
    };

    navigate("/search", { state: JSON.stringify(parameters) });
  }

  return (
    <>
      <Spinner visibility={spinnerVisibility} />
      <div
        id="channels-grid"
        className="px-3  mx-auto logos-container flex flex-wrap gap-5 justify-center mt-10 mb-10"
      >
        {channelsGrid != null && channelsGrid.length > 0 ? (
          channelsGrid.map((channel, index) => (
            <div
              id={channel.channelID}
              key={index}
              className="image-item w-[180px] h-auto rounded-[15px] overflow-hidden shadow-md transition transform hover:scale-105 hover:shadow-lg"
              onClick={() => loadSearchPage(channel.channelID)}
            >
              <img
                className="w-full h-full object-contain"
                src={
                  channel.channelName != null
                    ? config.channelsLogosUrl +
                      channel.channelName.replace(/\s+/g, "-") +
                      ".jpg"
                    : config.placeholderImageUrl
                }
                alt={channel.channelName}
              ></img>
            </div>
          ))
        ) : (
          <Alert
            severity="error"
            id="channels-grid-error"
            style={{
              display: showAlert ? "flex" : "none",
            }}
          >
            {alertMessage}
          </Alert>
        )}
      </div>
    </>
  );
}
